<div class="clamp-container" #container>
  <div class="clamp-header" #header>
    <ng-content select="[clampHeader]"></ng-content>
  </div>
  <div class="clamp-text ellipsis-multiline" #textBlock>
    <ng-content select="[clampText]"></ng-content>
  </div>
</div>
